import { StockDocumentPricingTable } from "./StockDocumentPricingTable"

export const StockDocumentPricingTableSection = StockDocumentPricingTable


// WEBPACK FOOTER //
// ./src/pricing/sections/index.ts